<template>
  <div id="foot-tab">
    <div class="tab" :class="isiOS ? 'active' : ''">
      <router-link to="/home" tag="span" class="home-tab"></router-link>
      <router-link
        class="classify-tab"
        @click.native="consoleMes()"
        to="/productFilter?hasHead=true"
        tag="span"
      ></router-link>
      <!-- <router-link class="vip-tab" to="/foot3?typeName=离我最近" tag="span"></router-link> -->
      <span class="meiTuan" @click="toMeituan()" v-if="sourceType!=3">
        <wx-open-launch-weapp
          id="launch-btn"
          username="gh_870576f3c6f9"
          :path="wxPath"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
        >
          <script type="text/wxtag-template">
            <style>.btn { padding: 12px;opacity:0 }</style>
               <button class="btn">打开小程序</button>
          </script>
        </wx-open-launch-weapp>
      </span>

      <router-link class="mine-tab" to="/mine" tag="span"></router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      wxPath: "",
      isiOS: false,
      //   isindexAct: true,
      sourceType: "",
    };
  },
  mounted() {
    var that = this;
    this.sourceType = localStorage.sourceType;
    // if (localStorage.sourceType == 2) {
    // 	that.wxPath = "index/pages/h5/h5?lch=mhqIykekFEV63u81zLSTaQViQ&noshare=1&f_userId=0&f_openId=0&f_token=0&weburl=https%3A%2F%2Fdpurl.cn%2FQUo72Glz"
    // } else if(localStorage.sourceType == 1){
    // 	that.wxPath = "index/pages/h5/h5?lch=mhqIykekFEV63u81zLSTaQViQ&noshare=1&f_userId=0&f_openId=0&f_token=0&weburl=https%3A%2F%2Fdpurl.cn%2FSWo0yGfz"
    // }

    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      that.isiOS = true;
    }

    console.log(1111);
    // setTimeout(function () {
    // 	console.log(sessionStorage.getItem("wxJsIsReady"));
    // 	if (sessionStorage.getItem("wxJsIsReady") != "true") {
    // 		that.getWxMes();
    // 	}

    // },1000)

    that.wxPath = localStorage.getItem("meiTuanUrl");

    var btn = document.getElementById("launch-btn");
    btn.addEventListener("launch", function (e) {
      console.log("success");
    });
    btn.addEventListener("error", function (e) {
      alert("小程序打开失败");
      console.log("fail", e.detail);
    });
  },
  methods: {
    consoleMes() {
      localStorage.setItem("selectValue", "");
      localStorage.setItem("menuNum", -1);
    },
    toMeituan() {
      console.log("美团");
      // window.location.href = "https://act.meituan.com/clover/page/adunioncps/coupon_shop?utmSource=90182&utmMedium=3E6FB3C8CEA06A34D0DF70015F62CD3A&activity=0AlN4OtEIa&promotionId=38747&sessionUuid=9dc9b4f0-27e3-41c4-8dc8-5675e7cce59d";
    },
    getWxMes() {
      var that = this;

      that.http
        .getWxSignature({
          url: window.location.href.split("#")[0],
        })
        .then((res) => {
          console.log(res.data);
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
            appId: res.data.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.data.signature, // 必填，签名
            jsApiList: ["wx-open-launch-weapp"], // 必填，需要使用的JS接口列表
            openTagList: ["wx-open-launch-weapp"], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          });
        });

      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        sessionStorage.setItem("wxJsIsReady", "true");
      });
    },
  },
};
</script>

<style lang="scss">
#foot-tab {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 99;
  width: 100vw;
  background-color: #fff;
  border-top: 1px solid #eee;
  box-shadow: 0px 0px 0.18rem #eaeaea;
  max-width: 750px;
  transform: translateX(-50%);

  .tab {
    display: flex;
    justify-content: space-around;
    padding: 0.11rem 0px 0rem;

    span {
      display: inline-block;
      background-size: contain;
      background-repeat: no-repeat;
    }

    .home-tab {
      width: 0.64rem;
      height: 0.64rem;
      background-image: url("../assets/footIco1.png");
    }

    .home-tab.router-link-active {
      background-image: url("../assets/footIco2.png");
    }

    .classify-tab {
      font-size: 0.2rem;
      width: 0.49rem;
      height: 0.77rem;
      background-image: url("../assets/footIco3.png");
    }
    // .classify-tab span{
    // 	white-space: nowrap;
    // 	margin-top: .6rem;

    // }
    .classify-tab.router-link-active {
      background-image: url("../assets/footIco4.png");
    }

    .vip-tab {
      width: 0.8rem;
      height: 0.77rem;
      background-image: url("../assets/footIco5.png");
    }

    .vip-tab.router-link-active {
      background-image: url("../assets/footIco6.png");
    }

    .mine-tab {
      width: 0.38rem;
      height: 0.74rem;
      background-image: url("../assets/footIco7.png");
    }

    .mine-tab.router-link-active {
      background-image: url("../assets/footIco8.png");
      //   background-image: url("../assets/footIco8.png");
    }

    .meiTuan {
      width: 0.68rem;
      height: 0.77rem;
      background-image: url("../assets/footIco9.png");
      position: relative;
    }
    .meiTuan.router-link-active {
      background-image: url("../assets/footIco8.png");
    }
  }
  .tab.active {
    padding-bottom: 0.28rem;
  }
}
</style>
